import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type {
  AdminOrderMonitoringDetailView,
  AdminOrdersPage,
  AdminOrdersQuery,
} from 'shared-models/browser';

export type {
  AdminOrderMonitoringDetailView,
  AdminOrdersPage,
  AdminOrdersQuery,
} from 'shared-models/browser';
export type { AdminOrdersSortKey } from 'shared-models/browser';

class AdminOrdersService {
  async updateOpeningWaiter(tenantId: string, orderId: number, employeeId: number): Promise<void> {
    await authenticatedInstance.patch(`/orders/admin/tenant/${encodeURIComponent(tenantId)}/${orderId}/opening-waiter`, {
      openedByEmployeeId: employeeId,
    });
  }

  async list(query: AdminOrdersQuery = {}): Promise<AdminOrdersPage> {
    try {
      const response = await authenticatedInstance.get<AdminOrdersPage>('/payments/admin/orders', { params: query });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }

  async getDetail(orderId: number): Promise<AdminOrderMonitoringDetailView> {
    try {
      const response = await authenticatedInstance.get<AdminOrderMonitoringDetailView>(`/payments/admin/orders/${orderId}`);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }
}

export const adminOrdersService = new AdminOrdersService();
